"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScenarioRequestType = exports.ResourceType = exports.PublishScenarioStatus = exports.CriteriaOptionType = void 0;
let ResourceType = exports.ResourceType = /*#__PURE__*/function (ResourceType) {
  ResourceType["NODE"] = "Concept";
  ResourceType["LINK"] = "Link";
  ResourceType["INSIGHT"] = "Insight";
  ResourceType["TRANSACTION_NODE"] = "TransactionDataNode";
  ResourceType["TREE"] = "Tree";
  ResourceType["UNKNOWN"] = "Unknown";
  return ResourceType;
}({});
let PublishScenarioStatus = exports.PublishScenarioStatus = /*#__PURE__*/function (PublishScenarioStatus) {
  PublishScenarioStatus[PublishScenarioStatus["OPEN"] = 1] = "OPEN";
  PublishScenarioStatus[PublishScenarioStatus["APPROVE"] = 2] = "APPROVE";
  PublishScenarioStatus[PublishScenarioStatus["REJECT"] = 3] = "REJECT";
  PublishScenarioStatus[PublishScenarioStatus["ABANDON"] = 4] = "ABANDON";
  return PublishScenarioStatus;
}({});
let ScenarioRequestType = exports.ScenarioRequestType = /*#__PURE__*/function (ScenarioRequestType) {
  ScenarioRequestType[ScenarioRequestType["REQUESTS"] = 1] = "REQUESTS";
  ScenarioRequestType[ScenarioRequestType["APPROVALS"] = 2] = "APPROVALS";
  return ScenarioRequestType;
}({});
let CriteriaOptionType = exports.CriteriaOptionType = /*#__PURE__*/function (CriteriaOptionType) {
  CriteriaOptionType[CriteriaOptionType["Equals"] = 1] = "Equals";
  CriteriaOptionType[CriteriaOptionType["Increase By"] = 2] = "Increase By";
  CriteriaOptionType[CriteriaOptionType["Decrease By"] = 4] = "Decrease By";
  CriteriaOptionType[CriteriaOptionType["Multiply By"] = 3] = "Multiply By";
  CriteriaOptionType[CriteriaOptionType["Increase By Percentage"] = 5] = "Increase By Percentage";
  CriteriaOptionType[CriteriaOptionType["Decrease By Percentage"] = 6] = "Decrease By Percentage";
  return CriteriaOptionType;
}({});
/** Array of resource ids from root to target specifying a path */